import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3ef20522")

_pushScopeId("data-v-3ef20522")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Namn")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("MP")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("MP")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("SK")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("BK")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("MP")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("SK")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("BK")
const _hoisted_9 = /*#__PURE__*/_createVNode("h5", { class: "ion-text-center" }, "Matcher", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Skapa match ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_col = _resolveComponent("ion-col")
  const _component_ion_row = _resolveComponent("ion-row")
  const _component_ion_grid = _resolveComponent("ion-grid")
  const _component_ion_card_content = _resolveComponent("ion-card-content")
  const _component_ion_card = _resolveComponent("ion-card")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_base_layout = _resolveComponent("base-layout")

  return (_openBlock(), _createBlock(_component_base_layout, {
    "page-title": _ctx.group ? _ctx.group.name : 'Loading...',
    "page-default-back-link": "/home"
  }, {
    default: _withId(() => [
      _createVNode(_component_ion_card, { class: "ion-no-margin ion-margin-top" }, {
        default: _withId(() => [
          _createVNode(_component_ion_card_content, null, {
            default: _withId(() => [
              _createVNode(_component_ion_grid, { class: "group" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_row, { class: "header" }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_col, { size: "1" }),
                      _createVNode(_component_ion_col, {
                        size: "2",
                        class: "ion-text-left"
                      }, {
                        default: _withId(() => [
                          _hoisted_1
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, { size: "1" }, {
                        default: _withId(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, { size: "8" }, {
                        default: _withId(() => [
                          _createVNode(_component_ion_row, null, {
                            default: _withId(() => [
                              _createVNode(_component_ion_col, null, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_row, null, {
                                    default: _withId(() => [
                                      _createVNode(_component_ion_col, { size: "2" }, {
                                        default: _withId(() => [
                                          _hoisted_3
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_col, { size: "2" }, {
                                        default: _withId(() => [
                                          _hoisted_4
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_col, { size: "2" }, {
                                        default: _withId(() => [
                                          _hoisted_5
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_col, { size: "2" }, {
                                        default: _withId(() => [
                                          _hoisted_6
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_col, { size: "2" }, {
                                        default: _withId(() => [
                                          _hoisted_7
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_col, { size: "2" }, {
                                        default: _withId(() => [
                                          _hoisted_8
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.resultItems, (player, index) => {
                    return (_openBlock(), _createBlock(_component_ion_row, {
                      key: player.id
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_col, {
                          size: "1",
                          class: "header"
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(index + 1), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_ion_col, {
                          size: "2",
                          class: "ion-text-left"
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(player.name), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_ion_col, {
                          size: "1",
                          class: "border"
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(player.MP), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_ion_col, { size: "8" }, {
                          default: _withId(() => [
                            _createVNode(_component_ion_row, null, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(player.rounds, (r) => {
                                  return (_openBlock(), _createBlock(_component_ion_col, {
                                    size: "6",
                                    key: r
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_ion_row, null, {
                                        default: _withId(() => [
                                          _createVNode(_component_ion_col, { size: "4" }, {
                                            default: _withId(() => [
                                              _createTextVNode(_toDisplayString(r.MP), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_ion_col, { size: "4" }, {
                                            default: _withId(() => [
                                              _createTextVNode(_toDisplayString(r.SK), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_ion_col, {
                                            size: "4",
                                            class: "borderRight"
                                          }, {
                                            default: _withId(() => [
                                              _createTextVNode(_toDisplayString(r.BK), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _hoisted_9,
      _createVNode(_component_ion_grid, null, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.group.matches.filter((x) => x.games.length), (match) => {
            return (_openBlock(), _createBlock(_component_ion_row, {
              key: match.id,
              class: "match"
            }, {
              default: _withId(() => [
                _createVNode(_component_ion_col, { size: "2" }),
                _createVNode(_component_ion_col, {
                  size: "8",
                  class: "flex ion-justify-content-center ion-align-items-center"
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.getName(match.players[0])) + " - " + _toDisplayString(_ctx.getName(match.players[1])), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_ion_col, { size: "2" }, {
                  default: _withId(() => [
                    _createVNode(_component_ion_button, {
                      fill: "clear",
                      size: "small",
                      color: "dark",
                      onClick: ($event: any) => (_ctx.removeMatch(match.id))
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_icon, {
                          name: "trash",
                          slot: "icon-only"
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1024),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(match.games, (game) => {
                  return (_openBlock(), _createBlock(_component_ion_col, {
                    key: game,
                    class: "game ion-text-center"
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(game[0]) + " - " + _toDisplayString(game[1]), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }),
      (
				_ctx.group.nrOfMatches !==
					_ctx.group.matches.filter((x) => x.games.length).length
			)
        ? (_openBlock(), _createBlock(_component_ion_button, {
            key: 0,
            "router-link": `${_ctx.group.id}/addMatch`,
            expand: "full"
          }, {
            default: _withId(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["router-link"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["page-title"]))
})